<asax-result-table-search-table-cell-popover [text]="bibCode">
  <title *ngTemplateOutlet="publicationTitle"></title>
  <content *ngTemplateOutlet="publicationContent"></content>
</asax-result-table-search-table-cell-popover>

<ng-template #publicationTitle>
  <i class="fa-light fa-book me-1"></i>Publication {{bibCode}}
</ng-template>

<ng-template #publicationContent>
  <ng-container *ngIf="!isLoading; else loading">
    <ul class="list list-unstyled d-flex flex-column gap-2"
        style="overflow-y: auto;max-height: 50vh; max-width: 40vw;">
      <li><strong>BibCode</strong>: <a publicationLink [bibCode]="publication?.bibCode"></a></li>
      <li><strong>Title</strong>: <span [innerHTML]="publication?.title"></span></li>
      <li><strong>Authors</strong>: {{publication?.authors}}</li>
      <li><strong>Abstract</strong>: <span [innerHtml]="publication?.bibAbstract | highlight:  (headerPublicationAbstractSearchInputText | async)"></span>
      </li>
    </ul>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
